import * as React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Layout from '../../layout/cyLayout';
import CyHompage from './index';
import PracticePage from './practicePage';


const App: React.FC = () => {
  return (
    <Router>
      <Layout>
        <Route exact path='/' component={CyHompage} />
        <Route exact path='/practice' component={PracticePage} />
      </Layout>
    </Router>
  )
}

export default App